export const GET_ALL_ENVELOPES = 'GET_ALL_ENVELOPES';